<buttons-group [(buttons)]="btnGroupConfiguration" (onButtonGroupClick)="onButtonGroupClick($event)"></buttons-group>
<tabs></tabs>
